import { memo } from 'react';
import type { ShopSlotOverlayProps } from './ShopSlotOverlay.types';
import { Box } from '@bonanza-social/moonlight';
import ShopItemInfo from '../ShopItemInfo/ShopItemInfo';
import ShopSlotCooldownLabel from '../ShopSlotCooldownLabel/ShopSlotCooldownLabel';

function ShopSlotOverlay({ slot }: ShopSlotOverlayProps) {
  return (
    <Box
      position="absolute"
      top="space-0"
      bottom="space-0"
      left="space-0"
      right="space-0"
      justifyContent="center"
      alignItems="center"
    >
      <ShopSlotCooldownLabel cooldownEnd={slot.cooldownEnd} />
      <ShopItemInfo {...slot.item} />
      {slot.cooldownEnd ? (
        <Box
          position="absolute"
          zIndex={20}
          top="space-0"
          bottom="space-0"
          left="space-0"
          right="space-0"
          backgroundColor="transparentModalOverlayBackground"
        />
      ) : null}
    </Box>
  );
}

export default memo(ShopSlotOverlay);
